import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { searchInPatientList, setSortingPreference } from '../../../store/actions/inPatientAction';

interface ICustomSort {
  sortKey: string;
}
const CustomSort = ({ sortKey }: ICustomSort): ReactElement => {
  const dispatch = useDispatch();

  const handleSortAseconfing = (): any => {
    dispatch(setSortingPreference({ key: sortKey, value: 'ASCEND' }));
    dispatch(searchInPatientList());
  };
  const handleSortDeseconfing = (): any => {
    dispatch(setSortingPreference({ key: sortKey, value: 'DESCEND' }));
    dispatch(searchInPatientList());
  };

  return (
    <React.Fragment>
      <Popover
        content={
          <span className="inpatient_tooltip_header">
            Click to Sort Ascending
          </span>
        }
        placement="top"
      >
        <CaretUpOutlined
          className="sortAscendingBtn"
          onClick={handleSortAseconfing}
        />
      </Popover>
      <Popover
        content={
          <span className="inpatient_tooltip_header">
            Click to Sort Descending
          </span>
        }
        placement="bottom"
      >
        <CaretDownOutlined
          className="sortDescendingBtn"
          onClick={handleSortDeseconfing}
        />
      </Popover>
    </React.Fragment>
  );
};

export default CustomSort;
